import { plugin_registry } from 'nk-plugin-registry';
console.log(8989898989)

import "generics/scrollToTopButton";

plugin_registry.init();